import { UrlSegment, UrlMatchResult } from "@angular/router";

// Matches either '' or 'product-info' as the full path
export function defaultProductInfoMatcher(
  segments: UrlSegment[],
): UrlMatchResult | null {
  if (
    (segments.length === 1 && segments[0].path === "pia") ||
    (segments.length === 2 && segments[1].path === "product-info")
  ) {
    return { consumed: segments };
  }
  return null;
}
